import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
    usePagination,
    MenuItem,
    Select,
    TextField,
    InputAdornment,
    Tabs,
    Tab,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import handbooksService from "../../../services/handbooks.service";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import imgHandBooks from "../../../assets/images/news/img-manual-book.svg";
import background from "../../../assets/images/news/background.svg";
import PlayVideo from "../../../assets/images/icon_play.svg";
import HoverPlayVideo from "../../../assets/images/icon_hover_play.svg";
import cssVariables from "../../../theme/cssVariables";
import { ReactComponent as Arrow } from "../../../assets/images/faq/icon_arrow.svg";
import Search from "@mui/icons-material/Search";
import { LowPriority } from '@mui/icons-material';
import { height, maxWidth } from '@mui/system';
import * as Util from "../../../services/global.service";


const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    },

    paperContainer: {
        backgroundImage: `url(${background})`,
        width: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },
};





const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"

    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
    },

    processBgClickPlay: {
        border: " 2px solid #5DA196 !important",
        color: "#5DA196",
        "& > p > .MuiBox-root": {
            backgroundImage: `url(${PlayVideo})`,
            width: "22.5px",
            height: "22.5px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "relative",
        },
        "&:hover": {
            backgroundColor: "#5DA196 !important",
            color: "#FFFFFF",
            "& > p > .MuiBox-root": {
                backgroundImage: `url(${HoverPlayVideo})`,
            }
        },
    },


    processBgCompetency: {
        background: "#958CCB !important",
    },

})

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}



const ListBooks = () => {

    const { t } = useTranslation()

    const [mainData, setMainData] = React.useState([
        {
            books_type: [
                {

                    type: "rubric"

                },
                {

                    type: "kpi"
                },
                {

                    type: "common"
                }
            ],

            list: {
                rubric: [
                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319e",
                        title: "การวางแผนบันทึกข้อตกลง (Planning)",
                        excerpt: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
                        description: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },

                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319e",
                        title: "รายการผลงาน (Workload and performance)",
                        excerpt: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
                        description: "ssssssssssssssssssssssssssssssssssssssssss",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },



                ],

                kpi: [
                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319e",
                        title: "kpiiiiiiiiiiiiiiii",
                        excerpt: "aaaaaa",
                        description: "uuuuuuu",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },


                ],

                common: [
                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319e",
                        title: "common",
                        excerpt: "t666666",
                        description: "999999",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },


                ]
            },

        }

    ]);

    const [filteredList, setFilteredList] = React.useState([]);
    const [searchHandbook, setSearchHandbook] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [dataHandBooks, setDataList] = React.useState({});
    const [search, setSearchValue] = React.useState("");
    const [valueTab, setValueTab] = React.useState("");



    const handleChangeWorkloadType = (_, val) => {
        setCurrentPage(1);
        setValueTab(val);
    };



    const getListHandBook = () => {
        handbooksService.handbooks().then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {
                    setDataList(response.data)
                    setSearchHandbook(response.data);
                    for (let i = 0; i < response.data.books_type.length; i++) {
                        setValueTab(response.data.books_type[0].type);

                    }
                }


            },
        );
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }

    const dataSerachs = async (event) => {
        let result = {}
        let dataSerach = JSON.parse(JSON.stringify(dataHandBooks?.list))
        if (search !== "" && dataSerach !== undefined && Object.keys(dataSerach).length > 0) {
            for (let index = 0; index <= Object.keys(dataSerach).length - 1; index++) {
                let resultData = dataSerach[Object.keys(dataSerach)[index]].filter(rs => {
                    return Object.keys(rs).some(key => {

                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;


                    });
                });
                result[Object.keys(dataSerach)[index]] = resultData
            }
        } else {
            result = dataSerach;
        }
        await setSearchHandbook({ ...dataHandBooks, list: result });
        setFilteredList(result[valueTab]);
    };

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };

    // handle search

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    useEffect(() => {
        dataSerachs();
    }, [search]);

    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const handleTotalPage = () => {
        const List = filteredList
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    // update qty for each status when list changed
    useEffect(() => {
        handleTotalPage();

    }, [filteredList, perPage]);


    useEffect(() => {

        if (valueTab !== undefined && valueTab !== null && valueTab !== "") {
            setFilteredList(searchHandbook.list[valueTab])
        }
    }, [dataHandBooks, valueTab]);



    useEffect(() => {

        if (dataHandBooks !== undefined && dataHandBooks !== null && dataHandBooks !== "null") {
            getListHandBook();
        }
    }, []);

    useEffect(() => {
        handleTotalPage();
    }, [valueTab]);

    const currentTableData = useMemo(() => {
        handleTotalPage();
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return filteredList
            .slice(firstPageIndex, lastPageIndex);
    }, [filteredList, currentPage, perPage]);

    let { type } = useParams();
    useEffect(() => {


    }, []);

    const handleGoToDetail = (e) => {
        navigate(`/kpi/manual/contentbooks/${e}`, { replace: false });
    }

    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }




    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    width: '100%'
                }}
            >

                <Box style={styles.paperContainer}>
                    <Grid container pt={2} pb={2} sx={{ paddingLeft: '20px', paddingTop: '20px' }}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}> {t("handbook.label.homePage")}</span> / <span style={styles.end} >{t("handbook.label.userManualPage")}</span></Typography>
                    </Grid>

                    <Grid lg md xs={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <Grid lg md xs={4} display='flex' justifyContent='center'>
                            <img src={imgHandBooks} style={{ maxWidth: '470px', maxHeight: '470px' }}>

                            </img>
                        </Grid>
                        <Grid lg md xs={8} display='flex' justifyContent='center' flexDirection='column'>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography fontSize={64} lineHeight="70px" fontWeight={600} color="#404349"  >
                                    {t("handbook.label.handbooks")}
                                </Typography>
                                <Typography fontSize={24} lineHeight="32px" fontWeight={700} color="#404349" sx={{ paddingTop: "10px", textAlign: 'center' }}>
                                    {t("handbook.label.content")}
                                </Typography>

                            </Box>
                            <Grid item display='flex' justifyContent='center' mt="30px" >
                                <TextField
                                    id="input-with-icon-textfield"
                                    placeholder={t("news.label.search")}
                                    size="small"
                                    sx={{ background: "#fff", maxWidth: '660px', borderRadius: '5px', width: '100%' }}
                                    className="searchTextField-h48"
                                    value={search}
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search style={{ color: "#C4C4C4" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Grid container sx={{ borderBottom: "1px solid #e4e4e4" }} mt={4}>

                    <Typography fontSize={48} lineHeight="52px" fontWeight={600} color="rgba(93, 161, 150, 1)" sx={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "30px", width: "100%" }}>
                        {t("handbook.label.guidelines")}
                    </Typography>


                    {search !== "" ?
                        <Grid item lg md xs={12}>
                            <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" sx={{ paddingLeft: "40px", paddingTop: "20px" }}>
                                {t("handbook.label.reSearch")} <span style={{ fontWeight: "500" }}>"{search}"</span> {t("handbook.label.find")} {formatData(currentTableData.length, 0)} {t("handbook.label.result")}
                            </Typography>
                        </Grid>
                        : <Grid item lg={11} md={11} sx={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "20px", marginBottom: "18px" }} >
                            <Tabs
                                value={valueTab}
                                indicatorColor="primary"
                                onChange={handleChangeWorkloadType}
                                aria-label="Tabs"
                                TabIndicatorProps={{
                                    style: {
                                        height: "8px",
                                        fontSize: "16px",
                                        lineHeight: "24px",
                                        textColor: "rgba(93, 161, 150, 1)"
                                    },
                                }}
                            >
                                {dataHandBooks?.books_type !== undefined && dataHandBooks?.books_type !== null && dataHandBooks?.books_type.length > 0 ? dataHandBooks?.books_type.map((loRow) => (


                                    <Tab label={loRow.type} value={loRow.type} classes={{ root: classes.tab }} />


                                ))

                                    : null}
                            </Tabs>
                        </Grid>
                    }

                    {dataHandBooks?.books_type !== undefined && dataHandBooks?.books_type !== null && dataHandBooks?.books_type.length > 0 ? dataHandBooks?.books_type.map((loRow, index) => (
                        // dataHandBooks?.books_type !== undefined && dataHandBooks?.books_type !== null && dataHandBooks?.books_type.length > 0 ? dataHandBooks?.books_type.map((loRow) => (



                        <>

                            <Grid container sx={{ display: valueTab === loRow?.type ? 'block' : 'none' }} pb={5}>
                                {currentTableData !== undefined && currentTableData.length > 0 ?
                                    currentTableData.map((result, index) => (
                                        <Grid lg md xs={12} display="flex" alignItems='flex-start' sx={{ padding: "40px" }}>
                                            <Grid lg md xs={6} justifyContent='center' display='flex' >
                                                <Box sx={{ 'border-radius': '15px', border: '1px solid #CACACA', height: '100%', width: '100%' }}>
                                                    <img src={result.thumbnail} style={{ 'border-radius': '15px', display: 'block', height: '100%', width: '100%' }}>

                                                    </img>

                                                </Box>

                                            </Grid>
                                            <Grid lg md xs={6} justifyContent='flex-start' pl='30px' >
                                                <Typography fontSize={30} lineHeight="39.6px" fontWeight={600} color="#404349" >
                                                    {formatData(result.title, "-")}
                                                </Typography>

                                                <Typography fontSize={18} lineHeight="23.8px" fontWeight={400} color="#848484" sx={{ paddingTop: '10px', maxWidth }} dangerouslySetInnerHTML={{ __html: formatData(result.excerpt, "-") }}>

                                                </Typography>

                                                <Button className={classes.processBgClickPlay} sx={{ 'border-radius': '28px', marginTop: '35px', padding: '15px 20px' }} onClick={() => handleGoToDetail(result.serial)}>
                                                    <Typography fontSize={16} lineHeight="17.6px" fontWeight={500} sx={{ textAlign: 'center', display: 'flex', alignItems: 'center ' }}>
                                                        {t("handbook.label.clickPlay")}
                                                        <Box sx={{ marginLeft: '10px' }}></Box>
                                                    </Typography>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    ))

                                    : null}
                            </Grid>

                            {currentTableData?.length > 0 ?
                                <Grid container mt={1} spacing={2} sx={{ padding: '0px 40px 15px 40px' }} >
                                    <Grid item xs sm md display="flex" alignItems="center">
                                        <Box mr={1}>
                                            <Typography variant="s14_fw400" >{t("label.showMaxItems")}</Typography>
                                        </Box>
                                        <Select
                                            id="pagination"
                                            variant="outlined"
                                            defaultValue={10}
                                            value={perPage}
                                            onChange={handlePerPageChange}
                                            displayEmpty
                                            size="small"
                                            className="white-bg"
                                        >
                                            <MenuItem value={10}>
                                                <Typography style={{ fontWeight: "300" }}>10</Typography>
                                            </MenuItem>
                                            <MenuItem value={20}>
                                                <Typography style={{ fontWeight: "300" }}>20</Typography>
                                            </MenuItem>
                                            <MenuItem value={30}>
                                                <Typography style={{ fontWeight: "300" }}>30</Typography>
                                            </MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item display="flex" alignItems="center" ml="auto">
                                        <Typography variant="s14_fw400">
                                            {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                                        </Typography>
                                    </Grid>
                                    <Grid item ml="auto" display="flex" alignItems="center">
                                        <CustomPagination
                                            setCurrentPage={handleSetCurrentPage}
                                            selected={currentPage}
                                            count={totalPage}
                                        ></CustomPagination>
                                    </Grid>
                                </Grid>
                                : null}
                        </>

                        // ))
                        // : null

                    ))

                        : null}

                    <Box sx={{ display: 'flex', 'align-items': 'center', 'justify-content': 'center', width: '100%', height: '100%', paddingTop: "50px" }}>
                        <Typography fontSize={20} lineHeight="22px" fontWeight={400} color="#848484" >
                            {t("handbook.label.question")}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center', width: '100%', paddingTop: "26px", 'padding-bottom': '70px', cursor: "pointer" }} onClick={() => navigate("/kpi/faq/listfaq", { replace: false })}>
                        <Typography fontSize={18} lineHeight="19.8px" fontWeight={400} color="#5DA196" sx={{ paddingRight: "10px" }}>
                            {t("handbook.label.faqPage")}
                        </Typography>

                        <Arrow style={styles.arrow} />


                    </Box>


                </Grid>
            </Box>
        </>
    )
};
export default ListBooks;


